export { default } from './Image'